import React, { useState, useEffect } from "react";
import axios from "axios";

function PantoneColor({ hex }) {
    const [colorData, setColorData] = useState(null);

    useEffect(() => {
        axios
            .get(`https://www.thecolorapi.com/id?hex=${hex.replace("#", "")}`)
            .then((response) => {
                debugger
                setColorData(response.data);
            })
            .catch((error) => {
                console.error("Error fetching color data:", error);
            });
    }, [hex]);

    return (
        <div style={{ textAlign: "center" }}>
            {colorData ? (
                <div
                    style={{
                        backgroundColor: colorData.hex.value,
                        width: "150px",
                        height: "150px",
                        border: "1px solid #000",
                        margin: "10px auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontWeight: "bold",
                    }}
                >
                    {colorData.name.value}
                </div>
            ) : (
                <p>Loading...</p>
            )}
        </div>
    );
}

function TestingComponent() {
    return (
        <div>
            <h2>Pantone Color Details</h2>
            <PantoneColor hex="#FF5733" /> {/* Replace with a Pantone hex */}
        </div>
    );
}

export default TestingComponent;
